import React from 'react'
import { Route, Routes, } from 'react-router-dom';
import Homeone from '../components/Homeone/Main';
import About from '../components/About/Main';
import TeamDetails from '../components/TeamDetails/Main'
import Jobs from '../components/Jobs/Main'
import History from '../components/History/Main'
import Faq from '../components/Faq/Main'
import Services from '../components/Services/Main'
import Project from '../components/Project/Main'
import ProjectDetails from '../components/ProjectDetails/Main'
import Blog from '../components/Blog/Main'
import BlogDetails from '../components/BlogDetails/Main'
import Contact from '../components/Contact/Main';
import ItRecruitment from '../components/ItRecruitmentPage/Main';
import NonITRecruitment from '../components/NonITRecruitmentPage/Main';
import ExecutiveSearch from '../components/ExecutiveSearchPage/Main';
import CareerGuidance from '../components/CareerGuidancePage/Main';
import CampusHiring from '../components/CampusHiringPage/Main';
import DigitalHiringSolutions from '../components/DigitalHiringSolutionsPage/Main';
import HRConsulting from '../components/HRConsultingPage/Main';
import InternshipTrainingPrograms from '../components/InternshipTrainingProgramsPage/Main';
import Industry from '../components/IndustryPage/Main';
import DigitalMarketing from "../components/DigitalMarketingTrainginPage/Main"




function index() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Homeone />} />
               
                <Route path="/about" element={<About />} />
                
                <Route path="/industry" element={<Industry />} />
                <Route path="/teamdetails" element={<TeamDetails />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/history" element={<History />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/services" element={<Services />} />
                <Route path="/it-recruitment" element={<ItRecruitment />} />
                <Route path="/non-it-recruitment" element={<NonITRecruitment />} />
                <Route path="/executive-search" element={<ExecutiveSearch />} />
                <Route path="/career-guidance" element={<CareerGuidance />} />
                <Route path="/campus-hiring" element={<CampusHiring />} />
                <Route path="/digital-hiringsolutions" element={<DigitalHiringSolutions />} />
                <Route path="/hr-consulting" element={<HRConsulting />} />
                <Route path="/internship-training" element={<InternshipTrainingPrograms />} /> 
       <Route path="/digital-marketing" element={<DigitalMarketing />} />
                <Route path="/project" element={<Project />} />
                <Route path="/project-details" element={<ProjectDetails />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog-details" element={<BlogDetails />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </>
    )
}

export default index